import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tools: null,
  alertingTools: [],
  alertingTool: null,
  toolMappings: [],
  mappingDetails: null,
  alertingPolicies: [],
  alertingPolicy: {},
  createdPolicy: {},
  deletedPolicy: {},
  alertingPolicyByName: {},
  notificationSettings: [],
  addedNotificationType: [],
  deletedPolicyNotification: [],
  allAlertRecipients: [],
  customerAlertRecipients: [],
  customerToolPolicy: [],
  enableCustomerDefaultPolicy: [],
  disableCustomerDefaultPolicy: [],
  updateAlertRecipients: [],
  addAlertRecipients: [],
  toolDetails: [],
  loading: false,
  error: null,
  userProvisioning: '',
  addUserProvisioning: {},
};

const alertingToolsSlice = createSlice({
  name: 'alertingTools',
  initialState,
  reducers: {
    start: (state) => {
      state.loading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setAlertingTools: (state, action) => {
      state.alertingTools = action.payload;
      state.loading = false;
    },
    setCustomerToolPolicies: (state, action) => {
      state.customerToolPolicy = action.payload;
      state.loading = false;
    },
    setTools: (state, action) => {
      state.tools = action.payload;
      state.loading = false;
    },
    setAlertingTool: (state, action) => {
      state.alertingTool = action.payload;
      state.loading = false;
    },
    setToolDetails: (state, action) => {
      state.toolDetails = action.payload;
      state.loading = false;
    },
    setToolMappings: (state, action) => {
      state.toolMappings = action.payload;
      state.loading = false;
    },
    setNewToolMappings: (state, action) => {
      state.toolMappings = [...state.toolMappings, action.payload];
      state.loading = false;
    },
    setMappingDetails: (state, action) => {
      state.mappingDetails = action.payload;
      state.loading = false;
    },
    setAlertingPolicies: (state, action) => {
      state.alertingPolicies = action.payload;
      state.loading = false;
    },
    setAlertingPolicy: (state, action) => {
      state.alertingPolicy = action.payload;
      state.loading = false;
    },
    setNewAlertingPolicies: (state, action) => {
      state.alertingPolicies = [...state.alertingPolicies, action.payload];
      state.loading = false;
    },
    setAlertingPolicyByName: (state, action) => {
      state.alertingPolicyByName = action.payload;
      state.loading = false;
    },
    setAllAlertRecipients: (state, action) => {
      state.allAlertRecipients = action.payload;
      state.loading = false;
    },
    setAddAlertRecipients: (state, action) => {
      state.addAlertRecipients = action.payload;
      state.loading = false;
    },
    setCustomerAlertRecipients: (state, action) => {
      state.customerAlertRecipients = action.payload;
      state.loading = false;
    },
    setUpdateAlertRecipients: (state, action) => {
      state.updateAlertRecipients = action.payload;
      state.loading = false;
    },
    setNotificationSettings: (state, action) => {
      state.notificationSettings = action.payload;
      state.loading = false;
    },
    setAddedNotificationType: (state, action) => {
      state.addedNotificationType = action.payload;
      state.loading = false;
    },
    setDeletedPolicyNotification: (state, action) => {
      state.deletedPolicyNotification = action.payload;
      state.loading = false;
    },
    setEnableCustomersDefaultPolicy: (state, action) => {
      state.enableCustomerDefaultPolicy = action.payload;
      state.loading = false;
    },
    setDisableCustomersDefaultPolicy: (state, action) => {
      state.disableCustomerDefaultPolicy = action.payload;
      state.loading = false;
    },
    setUserProvisioningData: (state, action) => {
      state.userProvisioning = action.payload;
      state.loading = false;
    },
    setAddUserProvisioningData: (state, action) => {
      state.addUserProvisioning = action.payload;
      state.loading = false;
    },
    setResetAlertingTools: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAlertingTools,
  setTools,
  setAlertingTool,
  setToolDetails,
  setToolMappings,
  setNewToolMappings,
  setMappingDetails,
  setAlertingPolicies,
  setAlertingPolicy,
  setNewAlertingPolicies,
  setAlertingPolicyByName,
  setAllAlertRecipients,
  setAddAlertRecipients,
  setCustomerAlertRecipients,
  setUpdateAlertRecipients,
  setNotificationSettings,
  setAddedNotificationType,
  setDeletedPolicyNotification,
  setCustomerToolPolicies,
  setEnableCustomersDefaultPolicy,
  setDisableCustomersDefaultPolicy,
  setUserProvisioningData,
  setAddUserProvisioningData,
  setResetAlertingTools,
} = alertingToolsSlice.actions;

export default alertingToolsSlice.reducer;
